import { Invitation } from "../lib/supabase";

export interface CreateInvitationData {
  code: string;
  guest_names: string;
  ceremony: boolean;
  luncheon: boolean;
  reception: boolean;
  plus_one: boolean;
  family_allowed: boolean;
  plus_one_name?: string;
}

export interface UpdateInvitationData {
  code?: string;
  printed_code?: boolean;
  finalized?: boolean;
  sent?: boolean;
  guest_names?: string;
  ceremony?: boolean;
  luncheon?: boolean;
  reception?: boolean;
  rsvp_ceremony?: boolean;
  rsvp_luncheon?: boolean;
  rsvp_reception?: boolean;
  plus_one?: boolean;
  family_allowed?: boolean;
  family_attending?: number;
  bringing_plus_one?: boolean;
  plus_one_name?: string;
  rsvp?: boolean;
}

class InvitationsAPI {
  private baseUrl = "/api/invitations";

  async getAllInvitations(): Promise<Invitation[]> {
    const response = await fetch(this.baseUrl);
    if (!response.ok) {
      throw new Error("Failed to fetch invitations");
    }
    return response.json();
  }

  async createInvitation(
    invitationData: CreateInvitationData
  ): Promise<Invitation> {
    const response = await fetch(this.baseUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ...invitationData,
        code: invitationData.code.toUpperCase(),
      }),
    });

    if (!response.ok) {
      throw new Error("Failed to add invitation");
    }

    return response.json();
  }

  async updateInvitation(
    invitationId: string,
    updateData: UpdateInvitationData
  ): Promise<Invitation> {
    const response = await fetch(`${this.baseUrl}/${invitationId}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ...updateData,
        code: updateData.code?.toUpperCase(),
      }),
    });

    if (!response.ok) {
      throw new Error("Failed to update invitation");
    }

    return response.json();
  }

  async deleteInvitation(invitationId: string): Promise<void> {
    const response = await fetch(`${this.baseUrl}/${invitationId}`, {
      method: "DELETE",
    });

    if (!response.ok) {
      throw new Error("Failed to delete invitation");
    }
  }
}

export const invitationsAPI = new InvitationsAPI();
